exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3LUPa{width:100%;display:-ms-flexbox;display:flex;-ms-flex-pack:end;justify-content:flex-end;-ms-flex-align:center;align-items:center}.So1hv{width:87px;height:34px;outline:0;color:#fff;transition:color .3s ease,background-color .3s ease}.So1hv:focus{outline:0}._3pNhO{color:#fff;font-size:7px;width:8px;margin:0 4px}._1UL_v{display:none}._17CpI{color:hsla(0,0%,100%,.5)}", ""]);

// exports
exports.locals = {
	"custom-sizes": "_3LUPa",
	"customSizes": "_3LUPa",
	"text-input": "So1hv",
	"textInput": "So1hv",
	"separator": "_3pNhO",
	"submit": "_1UL_v",
	"inactive": "_17CpI"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader??ref--2-2!./node_modules/stylus-loader??ref--2-3!./src/widget/containers/share-overlay/embed-form/custom-size/custom-size.styl
// module id = 1433
// module chunks = mobile/mobile mobile-overlay/mobile-overlay full-screen-modals/full-screen-modals widget/strip widget/classic widget/compact